import React from 'react';
import moment from 'moment';
import { shortDate, fullDate } from '../../../core/date';

class TourDates extends React.Component {

  render() {
    const start = moment(this.props.start);
    if (!start.isValid()) {
      return (
        <span>
              -
        </span>);
    }
    return (
      <span>
        { shortDate(this.props.start) } - { fullDate(this.props.end)}
      </span>

    );
  }
}
export default TourDates;



// WEBPACK FOOTER //
// src/routes/booking/components/TourDates.js